import {useEffect, useState} from "react";
import {fetchESSOXApiToken} from "../auth/auth";

const useFetchRest = (url, params) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {

        const fetchData = async () => {
            setLoading(true);

            try {
                let token = await fetchESSOXApiToken(); // Fetch token first

                const requestOptions = {
                    method: "POST",
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json-patch+json",
                        "Accept": "application/json"
                    },
                    body: JSON.stringify(params) // Include request body
                };

                let res = await fetch(url, requestOptions);

                if (res.status === 401) {
                    console.warn("Token expired, refreshing...");
                    token = await fetchESSOXApiToken(); // Refresh token

                    requestOptions.headers["Authorization"] = `Bearer ${token}`; // Update token

                    res = await fetch(url, requestOptions);
                }

                const json = await res.json();

                setData(json)

            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

    }, [url]);

    return {loading, error, data};
};

export default useFetchRest;
